import React from "react";

import Option from "./Option";

function Options({
  options,
  questions,
  setAnswered,
  answered,
  handleSetUserPoints,
}) {
  return (
    <div className="option">
      {options.map((option, index) => (
        <Option
          option={option}
          key={index}
          questions={questions}
          index={index}
          setAnswered={setAnswered}
          answered={answered}
          handleSetUserPoints={handleSetUserPoints}
        />
      ))}
    </div>
  );
}

export default Options;
